import { fetchUser } from "actions/user";
import { MINUTE_DECIMAL_PLACES } from "constants/util";
import RequireData from "hooks/RequireData";
import React from "react";
import { Link } from "react-router-dom";
import fetchUserStatusSelector from "selectors/fetchUserStatus";
import userSelector from "selectors/user";
import { centHundredthsToString } from "utils/moneyFormat";

const BalanceCards: React.FC = () => {
    const [user] = RequireData(
        userSelector,
        fetchUserStatusSelector,
        fetchUser()
    );

    return (
        <div className="row">
            <div className="col-sm-6">
                <div className="card">
                    <div className="card-body">
                        <h5>Minutes Balance</h5>
                        <p>
                            This is the amount of minutes that you have. You can
                            either sell these or render you own Blender jobs
                            with them.
                        </p>
                        <h6>
                            {user === null
                                ? "loading"
                                : user.minutes_balance.toFixed(
                                      MINUTE_DECIMAL_PLACES
                                  )}{" "}
                            minutes
                        </h6>
                        <Link
                            to="/home/dashboard/balance/minutes"
                            className="btn btn-primary"
                        >
                            Manage
                        </Link>
                    </div>
                </div>
            </div>
            <div className="col-sm-6">
                <div className="card">
                    <div className="card-body">
                        <h5>Money Balance</h5>
                        <p>
                            This is the amount of money in your accout. You can
                            transfer it to your bank or buy minutes with it.
                        </p>
                        <h6>
                            {user === null
                                ? "loading"
                                : centHundredthsToString(
                                      user.money_balance_cent_hundredths
                                  )}
                        </h6>
                        <Link
                            to="/home/dashboard/balance/money"
                            className="btn btn-primary"
                        >
                            Manage
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BalanceCards;
